import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=2f4b639c&scoped=true&"
import script from "./DeleteUser.vue?vue&type=script&lang=js&"
export * from "./DeleteUser.vue?vue&type=script&lang=js&"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&id=2f4b639c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b639c",
  null
  
)

export default component.exports